export default {
  historyCards: (state) => state
}
